import { Point } from "geojson";

interface IConfig {
  backendBaseUrl: string;
  headquartersLocation: Point;
  googleMapsApiKey?: string | null;
}

const config: IConfig = {
  backendBaseUrl:
    window._env?.REACT_APP_BACKEND_BASE_URL || "http://localhost:8000",
  headquartersLocation: {
    type: "Point",
    coordinates: [4.476894194856043, 51.90776156137877],
  },
  googleMapsApiKey:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    window._env?.REACT_APP_GOOGLE_MAPS_API_KEY ||
    null,
};

export default config;
